module.exports = __webpack_public_path__ + "img/galeria-ornamentais-4.213c8986.jpg";